<template>
  <div class="app-navbar-actions">
    <!-- <VaButton
      v-if="!isMobile"
      preset="secondary"
      href="https://ui.vuestic.dev/support/consulting"
      target="_blank"
      color="textPrimary"
      class="app-navbar-actions__item flex-shrink-0 mx-0"
    >
      <VaIcon size="large" class="material-symbols-outlined mr-1">support_agent</VaIcon>
      {{ t('supportAndConsulting') }}
    </VaButton>     -->
    <RouterLink v-if="showWithdrawalCta" to="/payouts" class="app-navbar-actions__balance-btn">
      {{ withdrawalLabel }}
    </RouterLink>
    <a
      v-if="tipsPageUrl"
      :href="tipsPageUrl"
      target="_blank"
      rel="noopener noreferrer"
      class="app-navbar-actions__tips-btn"
      aria-label="Open my tip page"
    >
      <VaIcon name="open_in_new" size="18px" />
      <span class="app-navbar-actions__tips-btn-label">My tip page</span>
    </a>
    <NotificationDropdown class="app-navbar-actions__item mt-1" />
    <ProfileDropdown class="app-navbar-actions__item app-navbar-actions__item--profile" />
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import ProfileDropdown from './dropdowns/ProfileDropdown.vue'
import NotificationDropdown from './dropdowns/NotificationDropdown.vue'
import { useAuthStore } from '../../../stores/auth-store'

defineProps({
  isMobile: { type: Boolean, default: false },
})

const MIN_WITHDRAWAL_EUR = 20
const TIPS_BASE_URL = (import.meta.env.VITE_TIPS_BASE_URL ?? 'https://tips.hitip.app').replace(/\/$/, '')

const authStore = useAuthStore()
const { user } = storeToRefs(authStore)

const availableEurCents = ref(0)

const tipsPageUrl = computed(() => {
  const id = user.value?.composite_id
  return id ? `${TIPS_BASE_URL}/qr/${id}` : ''
})

const showWithdrawalCta = computed(
  () => !!user.value?.stripe_connect_account_id && availableEurCents.value > MIN_WITHDRAWAL_EUR * 100,
)

const withdrawalLabel = computed(() => `€${(availableEurCents.value / 100).toFixed(2)} available for withdrawal`)

async function loadAvailableBalance() {
  if (!user.value?.stripe_connect_account_id) {
    availableEurCents.value = 0
    return
  }

  const data = await authStore.getConnectBalance()
  const eurBucket = data?.available?.find((b) => b.currency.toLowerCase() === 'eur')
  availableEurCents.value = eurBucket?.amount ?? 0
}

onMounted(() => {
  void loadAvailableBalance()
})

watch(
  () => user.value?.stripe_connect_account_id,
  () => {
    void loadAvailableBalance()
  },
)
</script>

<style lang="scss">
.app-navbar-actions {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: 20px;

  .va-dropdown__anchor {
    color: var(--va-primary);
    fill: var(--va-primary);
  }

  &__item {
    border-radius: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    :hover {
      background-color: white;
    }

    svg {
      height: 20px;
    }

    &--profile {
      display: flex;
      justify-content: center;
    }

    .va-dropdown-content {
      background-color: var(--va-white);
    }

    @media screen and (max-width: 640px) {
      margin-left: 0;
      margin-right: 0;

      &:first-of-type {
        margin-left: 0;
      }
    }
  }

  &__balance-btn {
    padding: 8px 14px;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.25;
    color: #fff;
    text-decoration: none;
    background: #0073e6;
    border: none;
    border-radius: 8px;
    white-space: nowrap;
    transition: background-color 0.15s ease;

    &:hover {
      background: #0062c4;
      color: #fff;
    }

    @media screen and (max-width: 640px) {
      display: none;
    }
  }

  &__tips-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    height: 34px;
    padding: 0 12px;
    font-size: 13px;
    font-weight: 600;
    line-height: 1;
    color: #fff;
    text-decoration: none;
    background: #0073e6;
    border-radius: 8px;
    white-space: nowrap;
    flex-shrink: 0;
    transition: background-color 0.15s ease;

    &:hover {
      background: #0062c4;
      color: #fff;
    }

    @media screen and (max-width: 640px) {
      width: 34px;
      padding: 0;
    }
  }

  &__tips-btn-label {
    @media screen and (max-width: 640px) {
      display: none;
    }
  }

  .fa-github {
    color: var(--va-on-background-primary);
  }
}
</style>
